import React from 'react'
import { useTranslation } from 'react-i18next'
import * as R from 'remeda'

import {
  type FiveSegment,
  type FiveSegmentIndicator,
  fiveSegmentIndicatorLabelI18nKeyMap,
  fiveSegmentLabelI18nKeyMap,
  formatNineSegment,
  mapNineSegment,
  type NineSegment,
  type NineSegmentIndicator,
  nineSegmentIndicatorLabelMap,
  wrapFiveSegmentIndicatorLabelWithTranslate,
  wrapFiveSegmentLabelMapWithTranslate,
} from '~/utils'

export const useIndicatorLabelMap = () => {
  const { t } = useTranslation()

  const indicatorLabelMap: Record<
    FiveSegment | FiveSegmentIndicator | NineSegment | NineSegmentIndicator,
    string
  > = React.useMemo(
    () =>
      R.mapValues(
        {
          ...wrapFiveSegmentLabelMapWithTranslate(
            fiveSegmentLabelI18nKeyMap,
            t,
          ),
          ...wrapFiveSegmentIndicatorLabelWithTranslate(
            fiveSegmentIndicatorLabelI18nKeyMap,
            t,
          ),
          ...mapNineSegment((nineSegment) =>
            formatNineSegment(nineSegment, '%t', t),
          ),
          ...nineSegmentIndicatorLabelMap,
        },
        (label) => label.replace('\n', ' '),
      ),
    [t],
  )

  return indicatorLabelMap
}
